import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { GalleryModalComponent } from '../../../../../shared/components/gallery-modal/gallery-modal.component';
import { CdnifyPipe } from '../../../../../shared/pipes/cdnify.pipe';
import { ImageByCodePipe } from '../../../../../shared/pipes/image-by-code.pipe';
import { ICruiseDetail } from '../../interfaces/icruise-detail';
import { WidgetService } from '../../../../../shared/services/widget.service';
import { PostMessageService } from '../../../../../shared/services/post-message.service';

@Component({
  selector: 'app-cruise-detail-gallery',
  templateUrl: './cruise-detail-gallery.component.html',
  styleUrls: ['./cruise-detail-gallery.component.scss'],
})
export class CruiseDetailGalleryComponent implements OnInit, OnDestroy {
  private _cruise$: Observable<ICruiseDetail>;
  @Input()
  set cruise$(value: Observable<ICruiseDetail>) {
    this._cruise$ = value;
    if (this._cruise$) {
      this.subscribeToCruise();
    }
  }

  get cruise$(): Observable<ICruiseDetail> {
    return this._cruise$;
  }
  public loadingGalleryModalStatus: boolean = false;
  public loadingGalleryModalMessage: string = 'Caricamento...';
  public cruiseSubscription: Subscription;
  public galleryData: string[] = [];

  private isWidget: boolean;

  private isWidgetSubscription: Subscription;
  private returnedStrings: Set<string> = new Set<string>();

  constructor(
    private _modalService: NgbModal,
    private _cdnifyPipe: CdnifyPipe,
    private _imageByCodePipe: ImageByCodePipe,
    private _widgetService: WidgetService,
    private _postMessageService: PostMessageService
  ) {}

  ngOnInit(): void {
    this.isWidgetSubscription = this._widgetService
      .isWidget()
      .subscribe((isWidget) => {
        this.isWidget = isWidget;
      });

    if (this._cruise$) {
      this.subscribeToCruise();
    }
  }

  ngOnDestroy(): void {
    this.isWidgetSubscription?.unsubscribe();
    this.cruiseSubscription?.unsubscribe();
  }

  openGallery(stepCode: string): void {
    const element = this.galleryData.find((x: string) => x.includes(stepCode));
    const modalRef = this._modalService.open(GalleryModalComponent, {
      size: 'xl',
      windowClass: this.isWidget ? '' : 'modal-full',
    });
    modalRef.componentInstance.elements = this.galleryData;
    modalRef.componentInstance.selectedElement = element;
  }

  private subscribeToCruise(): void {
    this.cruiseSubscription = this.cruise$
      .pipe(
        map((e) => {
          return e.steps.filter((x) => !x.isNavigation);
        }),
        mergeMap((e) => {
          const harbors = e.flatMap(step => step.harbours);
          return forkJoin([
            ...harbors.map(x => this._imageByCodePipe.transform(x.data.Code, 'harbour')),
          ]);
        }),
        map((e) => {
          return e.map((x: string) => this._cdnifyPipe.transform(x))
            .filter((url: string) => !url.includes('placeholder'));
        }),
        map((e: string[]) => Array.from(new Set(e)))
      )
      .subscribe((e) => {
        this.galleryData = e;
      });
  }
}
